import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesByVendorComponent from './sales-by-vendor.component';

let SalesByVendorModule = angular
  .module('SalesByVendor', [
    uiRouter
  ])
  .component('salesByVendor', SalesByVendorComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesByVendor', {
      url: '/sales-by-vendor',
      data: {
        authRequired: true,
        permsRequired: ['sales-by-vendor']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'salesByVendor'
        }
      }
    })
  })
  .name;

export default SalesByVendorModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-vendor/sales-by-vendor.module.js